// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

// A poor man's approximation of http://www.w3.org/TR/web-animations/ that
// can run in a Worker if needed.

class Timeline {
	onplay: () => void;
	onstop: () => void;

	private _animations: Animation[] = [];
	private _running = false;

	get running() {
		return this._running;
	}

	sample(now: number) {
		const remove: Animation[] = [];
		for (let i = 0, n = this._animations.length; i < n; ++i) {
			const anim = this._animations[i];
			const start = anim._start;
			const duration = anim._duration;
			const frac = Math.max(0, Math.min((now - start) / duration, 1));
			anim._effect(frac);

			if (frac === 1) {
				if (anim.onfinish)
					anim.onfinish(anim);
				remove.push(anim);
			}
		}
		this._animations = this._animations.filter((anim: Animation) => {
			return !remove.some((anim2: Animation) => {
				return anim === anim2;
			});
		});
		if (this._animations.length === 0 && this._running) {
			this._running = false;
			if (this.onstop)
				this.onstop();
		}
	}

	removeAnimation(animation: Animation) {
		this._animations = this._animations.filter((anim: Animation) => {
			return animation !== anim;
		});
		if (this._animations.length === 0 && this._running) {
			this._running = false;
			if (this.onstop)
				this.onstop();
		}
	}

	addAnimation(animation: Animation) {
		this._animations.push(animation);
		if (this._animations.length > 0 && !this._running) {
			this._running = true;
			if (this.onplay)
				this.onplay();
		}
	}
}

export const timeline = new Timeline;

export class Animation {
	_start: number = 0;
	onfinish: Animation.FinishCallback;

	constructor(public _duration: number, public _easing: string, public _effect: Animation.EffectCallback) {}

	play() {
		this._start = flipp.now();
		timeline.addAnimation(this);
	}

	stop() {
		timeline.removeAnimation(this);
	}
}

export namespace Animation {
	export type EffectCallback = (frac: number) => void;
	export type FinishCallback = (anim: Animation) => void;
}

